import React, { useEffect, useMemo } from 'react'
import {
  useMap,
  Marker,
  APIProvider,
  Map as GoogleMap,
} from '@vis.gl/react-google-maps'

import { locations } from '@/constants'
import { yerevanSlug } from '@/utils'

const MapView: React.FC = () => {
  const map = useMap()

  const locationDetails = useMemo(() => locations[yerevanSlug], [])

  useEffect(() => {
    if (locationDetails && map) {
      map.moveCamera({
        center: {
          lat: +locationDetails.pickUpLatitude,
          lng: +locationDetails.pickUpLongitude,
        },
      })
    }
  }, [locationDetails, map])

  return (
    <div className="contact-map">
      <GoogleMap
        defaultZoom={11}
        zoomControl={false}
        mapId="custom-map-id"
        disableDefaultUI={false}
        fullscreenControl={false}
        defaultCenter={{
          lat: +locationDetails.pickUpLatitude,
          lng: +locationDetails.pickUpLongitude,
        }}
        zoomControlOptions={{ position: 9 }}
        style={{ width: '100%', height: '100%' }}
      >
        <Marker
          position={{
            lat: +locationDetails.pickUpLatitude,
            lng: +locationDetails.pickUpLongitude,
          }}
        />
      </GoogleMap>
    </div>
  )
}

export const Map: React.FC = () => (
  <APIProvider apiKey={process.env.NEXT_PUBLIC_GOOGLE_API_KEY as string}>
    <MapView />
  </APIProvider>
)
